import { render } from "./Portifolio.vue?vue&type=template&id=165734ff&scoped=true"
import script from "./Portifolio.vue?vue&type=script&lang=js"
export * from "./Portifolio.vue?vue&type=script&lang=js"

import "./Portifolio.vue?vue&type=style&index=0&id=165734ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-165734ff"]])

export default __exports__